module.exports = __webpack_public_path__ + "img/promo1.2366dde.png";